import {Component, Input} from '@angular/core';

@Component({
    selector: 'm4u-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {

    // @ts-ignore
    private LabelLines: string[] = [];

    @Input() set Label(value: string){
        this.LabelLines = value ? value.split('\n') : [];
    }
}
